import { ApiError, UnsupportedAppVersionError } from '@echo/api-client/client';

/** A Core call that answered with something other than success — carries the status for callers to decide on. */
export class OnEarlyRequestError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'OnEarlyRequestError';
    this.status = status;
  }
}

/**
 * Whether a failed write is worth trying again later: the network was away (fetch throws,
 * no status at all) or Core itself was in trouble. A 4xx means the request is wrong and
 * would fail the same way forever — except a 421: the request reached a region that is not
 * the person's home, which a fresh token fixes (the api client has already refreshed it);
 * and except Core refusing an old build: the same save goes through once the app is updated,
 * so it waits on the device.
 */
export function isRetryable(error: unknown): boolean {
  if (error instanceof UnsupportedAppVersionError) return true;
  if (error instanceof OnEarlyRequestError || error instanceof ApiError)
    return (
      error.status >= 500 || error.status === 408 || error.status === 421 || error.status === 429
    );
  return true;
}
